import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IMainDataFormMeta {
  // Authorization Data
  internalCode: FormInputMeta;
  externalCode: FormInputMeta;
  authorizationNumber: FormInputMeta;
  authorizationDate: FormInputMeta;
  referenceNumber: FormInputMeta;
  messageType: FormInputMeta;
  traceAuditNumber: FormInputMeta;
  responseCode: FormInputMeta;
  // Interface
  source: FormInputMeta;
  processing: FormInputMeta;
  destination: FormInputMeta;
  // Merchant
  merchantId: FormInputMeta;
  doingBusinessAs: FormInputMeta;
  merchantType: FormInputMeta;
  // Cardholder
  cardNumber: FormInputMeta;
  expiryDate: FormInputMeta;
  amount: FormInputMeta;
  currency: FormInputMeta;
  // Processing code
  transactionType: FormInputMeta;
  accountTypeFrom: FormInputMeta;
  accountTypeTo: FormInputMeta;
  // Authorization Status
  reversal: FormInputMeta;
  confirmation: FormInputMeta;
  matching: FormInputMeta;
  authorization: FormInputMeta;


  schema: any;
}

const mainDataFormMeta = {} as IMainDataFormMeta;

// Authorization Data
  mainDataFormMeta.internalCode = {
    name: 'internalCode',
    type: 'text',
    label: 'Code interne',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  mainDataFormMeta.externalCode = {
    name: 'externalCode',
    type: 'text',
    label: 'Code externe',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  mainDataFormMeta.authorizationNumber = {
    name: 'authorizationNumber',
    type: 'text',
    label: 'N° autorisation',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  mainDataFormMeta.authorizationDate = {
    name: 'authorizationDate',
    type: 'text',
    label: 'Date autorisation',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  mainDataFormMeta.referenceNumber = {
    name: 'referenceNumber',
    type: 'text',
    label: 'N° reference',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  mainDataFormMeta.messageType = {
    name: 'messageType',
    type: 'text',
    label: 'Type message',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  mainDataFormMeta.traceAuditNumber = {
    name: 'traceAuditNumber',
    type: 'text',
    label: 'N° trace audit',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  mainDataFormMeta.responseCode = {
    name: 'responseCode',
    type: 'text',
    label: 'Code réponse',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  // Interface
  mainDataFormMeta.source = {
    name: 'source',
    type: 'text',
    label: 'Source',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  mainDataFormMeta.processing = {
    name: 'processing',
    type: 'text',
    label: 'Traitement',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  mainDataFormMeta.destination = {
    name: 'destination',
    type: 'text',
    label: 'Destination',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  // Merchant
  mainDataFormMeta.merchantId = {
    name: 'merchantId',
    type: 'text',
    label: 'ID Marchand',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  mainDataFormMeta.doingBusinessAs = {
    name: 'doingBusinessAs',
    type: 'text',
    label: 'Entreprise',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  mainDataFormMeta.merchantType = {
    name: 'merchantType',
    type: 'text',
    label: 'Type marchand',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  // Cardholder
  mainDataFormMeta.cardNumber = {
    name: 'cardNumber',
    type: 'text',
    label: 'N° carte',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  mainDataFormMeta.expiryDate = {
    name: 'expiryDate',
    type: 'text',
    label: 'Date expiration',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  mainDataFormMeta.amount = {
    name: 'amount',
    type: 'text',
    label: 'Montant',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  mainDataFormMeta.currency = {
    name: 'currency',
    type: 'text',
    label: 'Devise',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  // Interface
  mainDataFormMeta.transactionType = {
    name: 'transactionType',
    type: 'text',
    label: 'Type transaction',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  mainDataFormMeta.accountTypeFrom = {
    name: 'accountTypeFrom',
    type: 'text',
    label: 'Type compte destination',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  mainDataFormMeta.accountTypeTo = {
    name: 'accountTypeTo',
    type: 'text',
    label: 'Type compte source',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  // Authorization Status
  mainDataFormMeta.reversal = {
    name: 'reversal',
    type: 'text',
    label: 'Revirement',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  mainDataFormMeta.confirmation = {
    name: 'confirmation',
    type: 'text',
    label: 'Confirmation',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  mainDataFormMeta.matching = {
    name: 'matching',
    type: 'text',
    label: 'Matching',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  mainDataFormMeta.authorization = {
    name: 'authorization',
    type: 'text',
    label: 'Autorisation',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }


mainDataFormMeta.schema = yup.object().shape(getValidationSchema(mainDataFormMeta));

export default mainDataFormMeta;